module.exports = __webpack_public_path__ + "static/dl-bc37674d4a5d50678d5c6ba1d421c671.jpg";